import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { GenericPage } from "./GenericPage";
import { H1, H2, Paragraph, Strong, InlineLinkAnchor, DefinitionList, Table } from "../theme/text";
export default () => markdown `

## Kontakt
${(<ReactSpecimen>
    <GenericPage>
      <H1>Kontakt</H1>

      <Paragraph>
        <Strong>Stadt Zürich</Strong>
        <br />
        <Strong>Statistik</Strong>
        <br />
        Napfgasse 6<br />
        8001 Zürich<br />
        Telefon <InlineLinkAnchor>+41 44 412 08 00</InlineLinkAnchor>
        <br />
        Fax <InlineLinkAnchor>+41 44 270 92 18</InlineLinkAnchor>
        <br />
        Email <InlineLinkAnchor>statistik@zuerich.ch</InlineLinkAnchor>
      </Paragraph>

      <H2>Telefonische Auskünfte</H2>

      <Paragraph>
        8.00 - 12.00 Uhr<br />
        13.00 - 17.00 Uhr
      </Paragraph>

      <H2>Postadresse</H2>

      <Paragraph>
        <Strong>Statistik Stadt Zürich</Strong>
        <br />
        Postfach<br />
        8022 Zürich
      </Paragraph>
    </GenericPage>
  </ReactSpecimen>)}

## Impressum
${(<ReactSpecimen>
    <GenericPage>
      <H1>Impressum</H1>

      <Paragraph>
        Statistik Stadt Zürich ist eine Dienstabteilung des
        Präsidialdepartements der Stadt Zürich. Als Zahlengedächtnis der
        Stadtverwaltung kümmert sich Statistik Stadt Zürich um die
        bedürfnisgerechte Vermittlung von statistischer Information an die
        Öffentlichkeit, Politik und Verwaltung.
      </Paragraph>

      <Paragraph>
        Spezialauswertungen, Erhebungen und eine Vielzahl weiterer
        Dienstleistungen ermöglichen aber auch die gezielte Beantwortung
        individueller Fragestellungen und das Realisieren kundenspezifischer
        Aufträge, und dies stets unter Berücksichtigung von Datenschutz und
        Datensicherheit.
      </Paragraph>

      <H2>Allgemeine Anwendungsfragen</H2>

      <Paragraph>
        <Strong>Stadt Zürich</Strong>
        <br />
        <Strong>Internetdienste</Strong>
        <br />
        Stadthausquai 17<br />
        Stadthaus<br />
        8001 Zürich<br />
        Telefon <InlineLinkAnchor>+41 44 412 30 99</InlineLinkAnchor>
      </Paragraph>

      <H2>Technik und Betrieb</H2>

      <Paragraph>
        <Strong>Stadt Zürich</Strong>
        <br />
        <Strong>Organisation und Informatik</Strong>
        <br />
        Albisriederstrasse 201<br />
        8047 Zürich
      </Paragraph>
    </GenericPage>
  </ReactSpecimen>)}

## Hinweise zur Barrierefreiheit
${(<ReactSpecimen>
    <GenericPage>
      <H1>Hinweise zur Barrierefreiheit</H1>

      <Paragraph>
        Der Webauftritt der Stadt Zürich ist weitgehend barrierefrei zugänglich.
      </Paragraph>

      <H2>Access-Keys</H2>

      <Paragraph>
        Access-Keys erlauben den schnellen Zugriff per Tastatur auf bestimmte
        Seiteninhalte: Auf der Website der Stadt Zürich sind sie wie folgt
        belegt:
      </Paragraph>

      <DefinitionList listItems={[
    "1 = zur Bereichsauswahl",
    "2 = zum Inhalt",
    "5 = zur Suche",
    "6 = zur Hilfsnavigation",
    "7 = zu den weiteren Informationen",
    "8 = zur Sprachauswahl",
    "L = Seite vorlesen"
]}/>

      <Paragraph>
        Die Tastenkombinationen zur Bedienung der Access-Keys sind abhängig vom
        Browser.
      </Paragraph>

      <H2>Nicht barrierefrei zugängliche Inhalte</H2>

      <Paragraph>
        Die folgenden Bereiche der Webseite sind noch nicht barrierefrei:
      </Paragraph>

      <Table headers={["Bereich", "Planung"]} rows={[
    ["Archiv 2002–2007", "Umsetzungstermin offen"],
    ["Archiv 2002–2008", "Umsetzungstermin offen"],
    ["Archiv 2002–2008", "Umsetzungstermin offen"]
]}/>

      <H2>Weitere Fragen? Informationen nicht gefunden?</H2>

      <Paragraph>
        Sind Sie auf hindernisfreie Webinhalte angewiesen? Haben Sie Fragen,
        Kritik oder andere Rückmeldungen? Dann wenden Sie sich an die die
        Internetdienste der Stadt Zürich.
      </Paragraph>

      <Paragraph>
        <Strong>Stadt Zürich</Strong>
        <br />
        <Strong>Internetdienste</Strong>
        <br />
        Stadthausquai 17<br />
        Stadthaus<br />
        8001 Zürich
        <br />
        8022 Zürich<br />
        Telefon <InlineLinkAnchor>+41 44 412 30 99</InlineLinkAnchor>
      </Paragraph>
    </GenericPage>
  </ReactSpecimen>)}

`;



// WEBPACK FOOTER //
// ./src/components/GenericPage.docs.tsx